(()=>{
  const arabicDigits=['٠','١','٢','٣','٤','٥','٦','٧','٨','٩'];
  const skipSelector='script,style,noscript,textarea,code,pre,[data-preserve-western-digits]';
  const localizedAttributes=['aria-label','title','placeholder','alt'];

  const localizeValue=(value)=>String(value)
    .replace(/[0-9]/g,(digit)=>arabicDigits[Number(digit)])
    .replace(/([٠-٩]),(?=[٠-٩])/g,'$1٬')
    .replace(/([٠-٩])\.(?=[٠-٩])/g,'$1٫');

  const localizeTextNode=(node)=>{
    if(!node?.nodeValue||!/[0-9]/.test(node.nodeValue))return;
    const parent=node.parentElement;
    if(!parent||parent.closest(skipSelector))return;
    node.nodeValue=localizeValue(node.nodeValue);
  };

  const localizeAttributes=(element)=>{
    if(!(element instanceof Element)||element.closest(skipSelector))return;
    localizedAttributes.forEach((attribute)=>{
      const value=element.getAttribute(attribute);
      if(value&&/[0-9]/.test(value))element.setAttribute(attribute,localizeValue(value));
    });
  };

  const localizeTree=(root)=>{
    if(!root)return;
    if(root.nodeType===Node.TEXT_NODE){
      localizeTextNode(root);
      return;
    }
    if(root.nodeType===Node.ELEMENT_NODE&&root.matches(skipSelector))return;
    if(root.nodeType===Node.ELEMENT_NODE)localizeAttributes(root);
    const walker=document.createTreeWalker(root,NodeFilter.SHOW_ELEMENT|NodeFilter.SHOW_TEXT,{
      acceptNode(node){
        if(node.nodeType===Node.ELEMENT_NODE&&node.matches(skipSelector))return NodeFilter.FILTER_REJECT;
        if(node.nodeType===Node.TEXT_NODE&&!/[0-9]/.test(node.nodeValue||''))return NodeFilter.FILTER_SKIP;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    let node=walker.nextNode();
    while(node){
      if(node.nodeType===Node.TEXT_NODE)localizeTextNode(node);
      else localizeAttributes(node);
      node=walker.nextNode();
    }
  };

  const start=()=>{
    localizeTree(document.body);
    const observer=new MutationObserver((mutations)=>{
      mutations.forEach((mutation)=>{
        if(mutation.type==='characterData')localizeTextNode(mutation.target);
        mutation.addedNodes.forEach((node)=>localizeTree(node));
      });
    });
    observer.observe(document.body,{subtree:true,childList:true,characterData:true});
  };

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
})();